import * as TurndownService from 'turndown';
const turndownService = (TurndownService as any).default({ headingStyle: 'atx' });

export function htmlToMarkdown(input: string): string {
  return turndownService.turndown(input);
}

export function escapeMarkdown(input: string): string {
  const content = turndownService.escape(input);
  return content?.replace(/\n/g, '\\n');
}